module.exports = __webpack_public_path__ + "static/media/8OLA14.4e6c5f03.jpg";